<div>
    <p>Getting lost is scary sometimes...</p>
    <table>
        <td><img alt="run1" src="assets/1.gif"/></td>
        <td><img alt="run2" src="assets/2.gif"/></td>
    </table>
    <button class="btn btn-lg btn-outline-primary" (click)="goHome()">Go back home</button>
</div>
